import classes from "./SlideShowKiosk.module.css";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";
import {useEffect, useState} from "react";
import arr from "../../../../store/link.jpg"

const SlideShowKiosk_redesign = (props) => {

    const [cards, setCards] = useState([])
    const [group, setGroup] = useState(props.groupID)
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    // Rotace slideshow – jen když máme alespoň 2 obrázky
    useEffect(() => {
        if (cards.length <= 1) return;
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => clearInterval(intervalId);
    }, [cards.length]);

    // Když se seznam změní (přidání/smazání), drž index v rozsahu
    useEffect(() => {
        if (cards.length === 0) {
            setCurrentIndexA(0);
            return;
        }
        setCurrentIndexA((i) => (i >= cards.length ? 0 : i));
    }, [cards.length]);
    // Načíst data hned + periodicky refresh (aby se po uploadu nová fotka objevila bez ručního reloadu)
    useEffect(() => {
        fetchDataCards(group);
        const refreshId = setInterval(() => fetchDataCards(group), 3000); // každé 3s (near-realtime)
        const onVis = () => {
            if (document.visibilityState === 'visible') fetchDataCards(group);
        };
        document.addEventListener('visibilitychange', onVis);
        return () => {
            clearInterval(refreshId);
            document.removeEventListener('visibilitychange', onVis);
        };
    }, [group])

    const  backHandler = () => {
        currentIndexA == 0?setCurrentIndexA(cards.length-1):setCurrentIndexA(currentIndexA-1)
    }
    const  nextHandler = () => {
        currentIndexA == cards.length-1?setCurrentIndexA(0):setCurrentIndexA(currentIndexA+1)
    }
    const safeIndex = cards.length > 0 ? (currentIndexA % cards.length) : 0;
    const current = cards.length > 0 ? cards[safeIndex] : null;
    return <div className={classes.mainRed}>
        {current && (
            <img
                key={current.id} 
                className={classes.imageRed}
                src={current.Body.imgURL}
                alt={current.Header || "image"}
            />
        )}
    </div>
}
export default SlideShowKiosk_redesign